 
<template>
  <el-select clearable v-model="tabName" :style="{width:width}" @change="getChooseLabel" filterable remote
    reserve-keyword :disabled="disabled" @clear="clearVal" :remote-method="remoteMethod" :loading="loading"
    :placeholder="placeholder" :size="size">
    <el-option v-for="(item,index) in labelList" :key="index" :label="item" :value="item">
    </el-option>
  </el-select>
</template>
<script>
import { getLabelDatabaseByNameNew } from "@/api/serviceOrder.js";

export default {
  data() {
    return {
      tabName: "",
      labelList: [],
      loading: false,
      hospitalName: ""
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "请选择标签"
    },
    size: {
      type: String,
      require: false,
      default: ""
    },
    tabNamePartent: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    },
    width: {
      type: String,
      require: false,
      default: ""
    }
  }, 
  mounted() {
    if(this.tabNamePartent){
      this.tabName = this.tabNamePartent
      this.remoteMethod(this.tabNamePartent)
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getLabelList(query);
      } else {
        this.labelList = [];
      }
    },
    getLabelList(keyword) {
      getLabelDatabaseByNameNew({
        redundant: keyword
      }).then(res => {
        this.loading = false;
        if (res.data) {
          this.labelList = res.data;
        } else {
          this.labelList = [];
        }
      });
    },
    clearVal() {
      this.getLabelList();
    },
    resettingVal() {
      this.tabName = "";
      this.getLabelList();
    },
    getChooseLabel(val) {
      this.$emit("getChooseLabel", val);
    }
  }
};
</script>